import { useCountdown } from 'core/common/hooks';
import { Typography } from 'core/common/ui/ui-kit';
import { addLeadingZero } from 'core/common/utils/addLeadingZero';
import { convertTimeToMinutesAndSeconds } from 'core/common/utils/convertTimeToMinutesAndSeconds';
import { FunnelName } from 'core/funnel/entities';
import {
  NumberWrapperStyled,
  TimerDividerStyled,
  TimerLabelStyled,
  TimerWrapperStyled,
} from './styled';

type TimerProps = {
  onTimeUp: () => void;
  labels?: {
    minutes: string;
    seconds: string;
  };
};

export const Timer = ({ onTimeUp, labels }: TimerProps) => {
  const { specialPlanCountdown } = useCountdown({
    key: FunnelName.APP_SUBSCRIPTION_4_7D_TRIAL_PER_DAY,
    onFinish: onTimeUp,
  });
  const { minutes, seconds } = convertTimeToMinutesAndSeconds(specialPlanCountdown);
  return (
    <TimerWrapperStyled>
      <NumberWrapperStyled>
        <Typography variant="h3">{addLeadingZero(minutes)}</Typography>
        {labels?.minutes && (
          <TimerLabelStyled variant="bodyExtraSmallRegular" color="textSecondary">
            {labels.minutes}
          </TimerLabelStyled>
        )}
      </NumberWrapperStyled>
      <TimerDividerStyled variant="h3">:</TimerDividerStyled>
      <NumberWrapperStyled>
        <Typography variant="h3">{addLeadingZero(seconds)}</Typography>
        {labels?.seconds && (
          <TimerLabelStyled variant="bodyExtraSmallRegular" color="textSecondary">
            {labels.seconds}
          </TimerLabelStyled>
        )}
      </NumberWrapperStyled>
    </TimerWrapperStyled>
  );
};
